export default `
const authenticatedLink = Canny('authenticateCannyLink', YOUR_FEEDBACK_LINK);
window.open(authenticatedLink, '_blank', 'noopener'); // open Canny in a new tab
`.trim();
